import React, { useEffect, useContext, useState, useRef } from 'react'

function GradioInterface() {
    return (
      <div
        style={{
          width: "100vw",
          height: "100vh",
          overflow: "hidden", // 🚫 Disable outer scroll
        }}
      >
        <iframe
          title="Gradio App"
          src="https://yatabase1-gradia.hf.space"
          width="100%"
          height="100%"
          style={{
            border: "none",
            overflow: "auto", // ✅ Scroll happens inside iframe
          }}
          allow="clipboard-write"
          sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
        />
      </div>
    );
  }
  
  export default GradioInterface;
  